var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import './theme-toggle.shape';
import React from 'jsx-dom';
import { listen } from '@exadel/esl/modules/esl-utils/decorators';
import { UIPPluginButton } from '../../core/button/plugin-button';
import { ThemeToggleIcon } from './theme-toggle.icon';
/** Theme switcher button-plugin for UI Playground widget */
export class UIPThemeSwitcher extends UIPPluginButton {
    connectedCallback() {
        super.connectedCallback();
        this._onThemeChange();
        this.appendChild(React.createElement(ThemeToggleIcon, null));
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.innerHTML = '';
    }
    onAction() {
        var _a;
        (_a = this.$root) === null || _a === void 0 ? void 0 : _a.toggleAttribute('dark-theme');
    }
    _onThemeChange() {
        var _a;
        this.$$attr('theme', ((_a = this.$root) === null || _a === void 0 ? void 0 : _a.hasAttribute('dark-theme')) ? 'dark' : 'light');
    }
}
UIPThemeSwitcher.is = 'uip-theme-toggle';
UIPThemeSwitcher.defaultTitle = 'Switch theme';
__decorate([
    listen({ event: 'uip:theme:change', target: ($this) => $this.$root })
], UIPThemeSwitcher.prototype, "_onThemeChange", null);
